import React from 'react';
import { MostCaptained, Game } from '../../types/types';
import { Paper, Tooltip, useTheme } from '@mui/material';
import { TeamLogos, TeamsList, TOOLTIPS } from '../../globals/Globals';
import { CardNumber, CardLabel } from '../../globals/styles';
import { IMAGES_BUCKET } from '../../configs/consts';

export interface Props {
    mostCaptained: MostCaptained;
}

const CaptainsCard = ({mostCaptained}:Props) => {
    const theme = useTheme();
    console.log("mostCaptained", mostCaptained);
    let player = mostCaptained.player;
    const lastgame:Game = player.stats[0].lastgame;
    const team = lastgame?.team?.name? lastgame.team.name : '';
    const colors = TeamsList[team]? TeamsList[team] : ['',''];
    const playerimg = `${IMAGES_BUCKET}${player.firstname}-${player.lastname}.png`;
    const teamLogo = TeamLogos[team]? TeamLogos[team] : '';
    let width = '200px'
    

    return <a href={`/player/${player.id}`}>
        <Paper style={{width: width,minWidth: width, position: "relative", textAlign: "center"}} className="playercard" elevation={3}>
        <div style={{
            background: `linear-gradient(120deg, ${colors[0]} 0%, ${colors[0]} 50%, ${colors[1]} 50%)`,
            borderTopRightRadius: 4,
            borderTopLeftRadius: 4,
        }}>
            <div style={{
                backgroundImage: `url("${playerimg}")`,
                backgroundSize: "contain",
                backgroundPosition: "center center",
                paddingBottom: "60%",
                backgroundRepeat:"no-repeat",
                //backgroundColor: "blue",
                borderTopRightRadius: 4,
                borderTopLeftRadius: 4
            }}>
                <div style={{position: "absolute", top: 6, left: 6}}>
                    <div style={{display:"flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start"}}>        
                        { /* <span style={{color: "white"}}>{player.stats[0]?.last5Games[0]?.team?.name}</span> */ }

                        <img style={{width: "30px", height: "30px"}} src={teamLogo} alt={team}/>
                    </div>
                </div>
                
            </div>
        </div>
        <div>
            <div style={{display: "flex", flexDirection: "column", padding: "1rem"}}>
                    <span>
                        <b style={{color: theme.palette.mode === 'dark' ? 'white' : "black"}}>
                            {player.firstname[0]}. {player.lastname}
                        </b>
                    </span>
                <div>
                    <Tooltip title={`% of teams that played ${player.firstname} ${player.lastname} as captain`}>
                        <CardNumber style={{color: "green", fontSize: "2rem"}}>
                            {mostCaptained.captain_percentage.toFixed(1)}
                            <span style={{fontSize: "1.5rem"}}>%</span>
                        </CardNumber>
                    </Tooltip>
                </div>
                <CardLabel>% Captain</CardLabel>
            </div>
        </div>
    </Paper>
    </a>
}


export default CaptainsCard;